var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
var Emoji_Reg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;

//md5加密
import crypto from 'crypto'
//DES
var CryptoJS = require("crypto-js");
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

export default {

    //检测请求码
    checkCode(obj, res) {
        if (res.msgCode == 0) {
            return true;
        }
        if (res.msgCode == 2530) {
            return true;
        }
        if (res.msgCode == 2998) {
            // obj.$alert("登录过期，请重新登录", '提示', {
            //     confirmButtonText: '确定',
            //     type: 'warning',
            //     callback: () => {
            //         window.location.href = '/login';
            //     }
            // });
            window.location.href = '/login';
        } else if(res.msgCode == 2993){
            obj.$alert("您的账号已在其他设备登录，如非本人操作，请重新登录修改密码",'提示', {
                type: 'warning',
                confirmButtonText: '确定',
                callback: action => {
                    window.location.href = '/login';
                }
            });
        }else if(res.msgCode == 2992){
            window.location.href = '/login';
        } else if(res.msgCode == 3004){
            obj.$alert("账号/密码输入错误，您的登录剩余有效次数为"+res.data.errorCount+"次。", '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            });
        }else if(res.msgCode == 3015){
            obj.$alert("登录失败，账号/密码输入错误次数过多，请"+res.data.remainTime+"分钟后重新登录。", '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            });
        }else if(res.msgCode == "SmsgCode"){
            obj.$alert(res.msg,'提示', {
                type: 'warning',
                confirmButtonText: '确定',
                callback: action => {
                    this.$api.logout().then((res) => {
                        if (this.$util.checkCode(this, res)) {
                        }
                    }).catch((err) => {
                        this.$util.showCatchErr(this, err, '退出登录失败');// 从数据库获取数据出现问题
                    });
                    window.location.href = '/login';
                }
            });
        }else {
            setTimeout(function(){
                obj.$alert(res.msg, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                });
            },300)
        }
        return false;
    },
    //请求失败
    showCatchErr(obj, err,msg,isImport = false) {
        let errorMsg="请求服务器失败，请稍后重试"
        /*if(err.toString().indexOf("Error: Request failed with status code")!=-1){
          errorMsg="请求服务器失败，状态码为"+err.toString().substring(err.toString().lastIndexOf(" "),err.toString().length);
        }*/
        if(err.toString().indexOf("timeout")!=-1){
            errorMsg="请求服务器超时";
        }
        if(err.toString()=="Error: Network Error"){
            errorMsg= isImport?"原因一：文件可能已被移至别处或遭到删除，原因二：网络错误，请稍后重试":"服务器失联，请稍后重试";
        }
        console.log(err)
        if(err.toString().indexOf("TypeError")!=-1){//前端代码异常或后台返回
            errorMsg="页面数据异常";
        }
        obj.$alert(msg?(msg+"，"+errorMsg):errorMsg, '提示', {
            confirmButtonText: '确定',
            type: 'warning'
        });
        return false;
    },
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    },
    toastShow(that, str,timer){//提示弹框
        that.isShow=true;
        that.errorInfo=str;
        setTimeout(function () {
            that.isShow=false;
        }, timer||1500);
    },
    checkProductType(rule, value, callback){
        var reg = /^[A-Za-z0-9\-]+$/ig;
        if (!reg.test(value)) {
            callback(new Error('设备型号由数字、字母、符号"-"组成'));
        }else {
            callback();
        }

    },
    checkEmojiNotNull(msg){
        var emojiNotNull=(rule, value,callback)=>{
            if (!value){
                callback(new Error(msg))
            }else  if (value.match(Emoji_Reg)){
                callback(new Error('不支持表情符号'))
            }else {
                callback()
            }
        }
        return emojiNotNull;
    },
    //判断是否包含表情符号
    checkEmoji(rule, value, callback) {
        if(!value){
            return callback();
        }
        if(value.match(Emoji_Reg)) {
            callback(new Error('不支持表情符号'));
        }else {
            callback();
        }
    },
    checkEmojiIF(value) {
        if(value.match(Emoji_Reg)) {
            return false;
        }else {
            return true;
        }
    },
    //去空格及换行----添加修改输入框
    checkBlank(rule, value, callback) {
        if (value) {
            value = value.replace(/^\s+|\s+$/g, '');
            if (!value) {
                callback(new Error('请输入有效字符'));
            } else if(value.match(Emoji_Reg)) {
                callback(new Error('不支持表情符号'));
            }else {
                callback();
            }
        } else {
            callback();
        }
    },
    //检测手机号
    checkPhoneNum(rule, value, callback) {
        if (value) {
            var reg = new RegExp("^1[3|4|5|6|7|8|9]\\d{9}$", "ig");
            if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号码'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },
//检测手机号,必填
  checkPhoneNumNotNull(rule, value, callback) {
    if (value) {
      var reg = new RegExp("^1[3|4|5|6|7|8|9]\\d{9}$", "ig");
      if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    } else {
      callback(new Error('请输入手机号码'));
    }
  },
    //检测手机号或座机号 非必填
    checkAllPhoneNum(rule, value, callback) {
        if (value) {
            let regstr = "";
            if (value.toString().substring(0, 1) == "1") {//修改住户的时候传递过来的value为number类型
                regstr = "^1[3|4|5|6|7|8|9]\\d{9}$";
            } else {
                regstr = "^(\(0\\d{2,3}\)|0\\d{2,3}-)\\d{7,8}$";
            }
            let reg = new RegExp(regstr, "ig");

            if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号或座机号'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },
    //检测是否为整数--回调方法
    checkInteger(rule, value, callback) {
        if (value) {
            var reg = new RegExp("^[0-9]*$", "ig");
            if (!reg.test(value)) {
                callback(new Error('请输入纯数字'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },
    // //检测是否为整数--公共方法
    checkInt(obj, value, hint) {
        var reg = new RegExp("^[0-9]*$", "ig");
        if(!value){
            return;
        }
        if (!reg.test(value)) {
            obj.$alert(hint, '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            });
            return false;
        }
        return true;
    },
    //检测是否为ip或域名 回调形式
    checkIP(rule, value, callback) {
        if (value) {
           /* var regIpStrAll = '([hH][tT]{2}[pP]:\\/\\/|[hH][tT]{2}[pP][sS]:\\/\\/)((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)(\\.((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)){3}';*/
            var regIpStr = '((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)(\\.((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)){3}';
            var regDomainStr = '[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?';
            var regIp = new RegExp(regIpStr, "ig");
            var regDomain = new RegExp(regDomainStr, "ig");
            if ((!regIp.test(value)) && (!regDomain.test(value))) {
                callback(new Error('请输入正确格式的通讯地址'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },
    //检测是否为ip或域名--公共方法 IP地址、前后有汉字、带参数的，都是OK的。
    checkIPAddress(obj, value) {
        if (!value) {
            return;
        }
        var regIpStr = '((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)(\\.((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)){3}';
        var regDomainStr = '[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?';
        var regIp = new RegExp(regIpStr, "ig");
        var regDomain = new RegExp(regDomainStr, "ig");
        if (!regIp.test(value) && !regDomain.test(value)) {
            obj.$alert("请输入正确格式的链接地址", '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            });
            return false;
        }
        return true;
    },
    //必填，人员账号检测只能数字和字母
    checkNumABC(rule, value, callback) {
        let errorMsg = "请输入以字母开头，长度在5~30之间，包含字母、数字格式的账号";
        if (!value) {
            return callback(new Error(errorMsg));
        }
        let reg = new RegExp("^[a-zA-Z][a-zA-Z0-9]{4,29}$", "ig");
        if (!reg.test(value)) {
            return callback(new Error(errorMsg));
        }
        callback();
    },
    checkAddRedix(rule, value, callback) {
        let errorMsg = "不能包含小数点";
        if (value.toString().indexOf('.')>-1) {
            return callback(new Error(errorMsg));
        }
        callback();
    },
    //仅支持中英文
    positiveInteger(msg,required){
        var f=(rule, value, callback) => {
            if (!value&&required) {
                return callback(new Error('请输入'+msg));
            }
            var reg =new RegExp("^[A-Za-z\u4e00-\u9fa5]+$");
            if (value&&!reg.test(value)) {
              return callback(new Error(msg+'只支持中英文'));
            }
            callback();
        }
        return f;
    },
    getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null)
            context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    guid() {
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g,
            function(c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
        })
    },
    formatDate: {
        //时间戳转时间
        formatStampsToTime(inputTime) {
            var date = new Date(inputTime);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            var h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? ('0' + minute) : minute;
            second = second < 10 ? ('0' + second) : second;
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        },
        formatget00(inputTime) {//用于商务收费 修改时间 起始时间重置为 00:00:00 格式
            var date = new Date(inputTime);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            var h = date.getHours();
            h = h < 10 ? ('0' + '0') : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? ('0' + minute) : minute;
            second = second < 10 ? ('0' + second) : second;
            console.log(y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second)
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        },
        //时间格式
        format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        //变成yyyy-MM-dd格式
        formatnoSecdDate(time) {
            if (!time) {
                return;
            }
           // return obj.$moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
        //    console.log(this.format(new Date(time), 'yyyy-MM-dd'))
            return this.format(new Date(time), 'yyyy-MM-dd');
           
        },
        //变成yyyy-MM-dd hh:mm:ss格式
        formatToRequiredDate(time) {
            if (!time) {
                return;
            }
           // return obj.$moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
            return this.format(new Date(time), 'yyyy-MM-dd hh:mm:ss');
        },
        //将时间的时分秒变成23：59：59
        formatToMaxDate(obj, time) {
            if (!time) {
                return;
            }
            time.setHours(23, 59, 59);
            return obj.$moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
        },
         //将时间的时分秒变成23：59：59
        formatToMaxDateanther(obj, time) {
            if (!time) {
                return;
            }
            // time.setHours(23, 59, 59);
            return obj.$moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
        },
        compareSearchTime(obj, begin, end) {
            if (!begin || !end) {
                return true;
            }
            let startTime = this.formatToRequiredDate(begin);
            let endTime = this.formatToMaxDate(obj, end);
            if (startTime >= endTime) {
                //window.alert("开始日期时间应小于结束日期时间");
                obj.$message({
                    message: '开始时间应小于结束时间！',
                    type: 'warning'
                });
                return false;
            };
            return true;
        },
        compareTime(obj, begin, end) {
            let startTime = this.format(new Date(begin), 'yyyy-MM-dd hh:mm:ss');
            let endTime = this.format(new Date(end), 'yyyy-MM-dd hh:mm:ss');
            // console.log(startTime,endTime)
            if (startTime >= endTime) {
                //window.alert("开始日期时间应小于结束日期时间");
                obj.$message({
                    message: '开始时间应小于结束时间！',
                    type: 'warning'
                });
                return false;
            };
            return true;
        },
        newCurTime(obj, begin, end) {
            let startTime = this.formatnoSecdDate(begin)
            let endTime = this.format(new Date(end), 'yyyy-MM-dd hh:mm:ss');
            // console.log(startTime,endTime)
            if (endTime<startTime) {
                //window.alert("开始日期时间应小于结束日期时间");
                obj.$message({
                    message: '当前起始日期不能小于之前起始日期！',
                    type: 'warning'
                });
                return false;
            };
            return true;
        },
        parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);
                            break;
                        case 'M':
                            _date.setMonth(_int - 1);
                            break;
                        case 'd':
                            _date.setDate(_int);
                            break;
                        case 'h':
                            _date.setHours(_int);
                            break;
                        case 'm':
                            _date.setMinutes(_int);
                            break;
                        case 's':
                            _date.setSeconds(_int);
                            break;
                    }
                }
                return _date;
            }
            return null;
        },
        //指定年月的该月份的天数
        monthDay(year, month) {
            month = parseInt(month, 10);
            var d = new Date(year, month, 0);  //这个是都可以兼容的
            var date = new Date(year + "/" + month + "/0")   //IE浏览器可以获取天数，谷歌浏览器会返回NaN
            return d.getDate();
        },
        getNextMonth: function (date,length) {
            let yy = date.getFullYear()
            let mm = date.getMonth()
            let dd = date.getDate()
    
            let nm= 0//目标月份
            nm = mm+length
            let nd = 0//目标天数
    
            if(this.monthDay(yy,nm+1)<dd){
            nd = this.monthDay(yy,nm+1)
            }else{
            console.log(dd)
            nd = dd
            }
    
            date.setDate(1)
            date.setMonth(nm)
            date.setDate(nd)
            return date
        },
        //获取当月最大天数
        mGetDate:function(year,month){
            var d = new Date(year,month,0);
            return d.getDate();
    
        },
        getNextDay: function (date,length) {
            let yy = date.getFullYear()
            let mm = date.getMonth()
            let dd = date.getDate()
            let dm= 0//目标天数
            dm = dd+length
            let ds = 0;
            let ms=0;//目标月份
            if(dm>this.mGetDate(yy,mm)){
                ms=mm+1;
                ds=dm-this.mGetDate(yy,mm);
            }else{
                ms=mm;
                ds=dm
            }
            date.setDate(1)
            date.setMonth(ms)
            date.setDate(ds)
            return date
        },
        getNexYear: function (date,length) {
            let yy = date.getFullYear()
            let mm = date.getMonth()
            let dd = date.getDate()
            date.setDate(1)
            date.setMonth(mm)
            date.setFullYear(yy+length)
            date.setDate(dd)
            return date
        },

    },
    formatStampsToTime() {
        var date = new Date();
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '' + m + '' + d + '' + h + '' + minute + '' + second;
    },
    formatNum(str) {
    //若是整数自动补全小数位
        if (-1 == str.indexOf(".")) {
            str = str + ".00"
        }
    //全部替换
        if (-1 != str.indexOf(",")) {
            str = str.replace(new RegExp(',', "g"), "")
        }
        var intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
        var dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
        var ret = intSum + dot;
        return ret;
    },
    //计算base64字节流的大小
    getBase64FileSize(data) {
        let str = data.substring(22);//1.去掉头部的data:image/png;base64,（注意有逗号）
        if (str.indexOf('=') > 0) {
            str = str.substring(0, str.indexOf('='));//去掉等号
        }
        let strLength = str.length;//原来的字符流大小，单位为字节
        return parseInt(strLength - (strLength / 8) * 2);//计算后得到的文件流大小，单位为字节
    },

    //分页跳转
    handleJumpInput(jumpTo) {
        if (!/^\d+$/.test(jumpTo)) {
            jumpTo ='';
        }
        return jumpTo;
    },
    handleJump(jumpTo,pageCount){
        if(jumpTo == ''){
            return jumpTo;
        }
        if(jumpTo > pageCount){
            jumpTo = pageCount;
        }
        if(jumpTo < 1){
            jumpTo = '1';
        }
        return jumpTo;
    },
    getmd5(value){
        var md5 = crypto.createHash("md5");
        md5.update(value);
        var a = md5.digest('hex');
        return a;
    },
    //处理json值拼接
    jsonSort(jsonObj) {
        let arr=[];
        let newJson={};
        for (var key in jsonObj){
            newJson[key.toLowerCase()] =jsonObj[key];
            arr.push(key.toLowerCase())
        }
        arr.sort();
        let str='';
        for(var i in arr){
            if(newJson[arr[i]]==undefined||newJson[arr[i]]==null){
                newJson[arr[i]]=''
            }
            str +=newJson[arr[i]]
        }
        return str;
    },
    // 解密
    decryptByAES(message, key) {
        let decrypt = CryptoJS.AES.decrypt(message,CryptoJS.enc.Utf8.parse(key), { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });

        let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return decryptedStr.toString();
    },
    // 加密
    encryptByAES(message, key) {
        var encrypted = CryptoJS.AES.encrypt(message, CryptoJS.enc.Utf8.parse(key), {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    },
    // 解密
    decryptByDES(ciphertext, key) {
        var keyHex = CryptoJS.enc.Utf8.parse(key)
        var decrypted = CryptoJS.DES.decrypt(
            {ciphertext:CryptoJS.enc.Base64.parse(ciphertext)},
            keyHex,
            {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
            }
        )
        let decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);
        return decodeURIComponent(decryptedStr);
    },
    // 加密
    encryptByDES(message, key) {
        var keyHex = CryptoJS.enc.Utf8.parse(key);
        var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    },
    htmlEncode(str){  
        var s = "";
        if(str.length == 0) return "";
        s = str.replace(/&/g,"&amp;");
        s = s.replace(/</g,"&lt;");
        s = s.replace(/>/g,"&gt;");
        s = s.replace(/ /g,"&nbsp;");
        s = s.replace(/\'/g,"&#39;");
        s = s.replace(/\"/g,"&quot;");
        
        return s;  
    },
     htmlDecode(str){  
        var s = "";
        if(str.length == 0) return "";
        s = str.replace(/&amp;/g,"&");
        s = s.replace(/&lt;/g,"<");
        s = s.replace(/&gt;/g,">");
        s = s.replace(/&nbsp;/g," ");
        s = s.replace(/&#39;/g,"\'");
        s = s.replace(/&quot;/g,"\"");
        return s;  
    },
    xss(str){
        if(str.length == 0) return "";
        str = str.replace(/&nbsp;/ig, '');// 去掉&nbsp;
        str = str.replace(/alert/gi, '');// 去掉alert;
        str = str.replace(/%3CSCRIPT/gi, '');// 去掉3CSCRIPT;
        str = str.replace(/input/ig, '');// 去掉input;
        str = str.replace(/iframe/ig, '');// 去掉iframe;
        str = str.replace(/window/ig, '');// 去掉window;
        str = str.replace(/link/ig, '');// 去掉link;
        str = str.replace(/location/ig, '');// 去掉location;
        str = str.replace(/JAVASCRIPT/ig, '');// 去掉JAVASCRIPT;
        str = str.replace(/update/ig, '');// 去掉update;
        str = str.replace(/insert/ig, '');// 去掉insert;
        str = str.replace(/select/ig, '');// 去掉select;
        str = str.replace(/script/ig, '');// 去掉select;
        return str;  
    },
    //将数字（整数）转为汉字，从零到一亿亿，需要小数的可自行截取小数点后面的数字直接替换对应arr1的读法就行了
    convertToChinaNum(num) {
        var arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
        var arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千','万', '十', '百', '千','亿');//可继续追加更高位转换值
        if(!num || isNaN(num)){
            return "零";
        }
        var english = num.toString().split("")
        var result = "";
        for (var i = 0; i < english.length; i++) {
            var des_i = english.length - 1 - i;//倒序排列设值
            result = arr2[i] + result;
            var arr1_index = english[des_i];
            result = arr1[arr1_index] + result;
        }
        //将【零千、零百】换成【零】 【十零】换成【十】
        result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
        //合并中间多个零为一个零
        result = result.replace(/零+/g, '零');
        //将【零亿】换成【亿】【零万】换成【万】
        result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
        //将【亿万】换成【亿】
        result = result.replace(/亿万/g, '亿');
        //移除末尾的零
        result = result.replace(/零+$/, '')
        //将【零一十】换成【零十】
        //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
        //将【一十】换成【十】
        result = result.replace(/^一十/g, '十');
        return result;
    }
};


// WEBPACK FOOTER //
// ./src/scripts/common/util.js